module.exports = { "default": require("core-js/library/fn/object/values"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/kea/~/babel-runtime/core-js/object/values.js
// module id = 832
// module chunks = 2